import { render, staticRenderFns } from "./systemNotifications.pug?vue&type=template&id=1c0fa84c&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./systemNotifications.scss?vue&type=style&index=0&id=1c0fa84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fa84c",
  null
  
)

export default component.exports